module.exports = __webpack_public_path__ + "img/plus.d55789c4.svg";